import { Alert } from 'antd';
import styled from 'styled-components';
export const CustomAlert = styled(Alert)`
  margin-bottom: 15px;
`;